/**
 * Resolves whether an id names a known agent, for the AI action validator
 * (`useAsk.ts`'s `isAgent`) and anywhere else that needs the same check.
 *
 * Reads `useWorld`'s live snapshot directly rather than subscribing, so it
 * stays correct across a live-roster swap without a render of its own:
 * once a Genesis-Live roster has replaced the static fallback
 * (`rosterLive`), only its real ids (`N0001…`) are valid — the static
 * ids are no longer what's on screen. Before that, the static registry is
 * the source of truth, exactly as it always was.
 *
 * Testable by driving the real store via `useWorld.setState(...)` before
 * calling this — see `test/agent-resolver.test.mjs`.
 */

import { isAgentId } from '../content/agents.ts';
import { useWorld } from '../lab/store.ts';

export function isKnownAgentId(id: string): boolean {
  const { agents, rosterLive } = useWorld.getState();
  return rosterLive ? agents.some((a) => a.id === id) : isAgentId(id);
}
